import './Headline.scss';

import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import Button from '@/common/components/atoms/Button/Button';
import { ReactComponent as ArrowLeftIcon } from '@/ebat/assets/icons/chevron-light-left.svg';
import ShowMoreName from '@/ebat/components/blocks/Product/ShowMoreName/ShowMoreName';

import { HeadlineDefaultProps, HeadlinePropTypes } from './Headline.proptypes';

const Headline = ({
  brand,
  className,
  complementaryDescription,
  goBack,
  lengthName,
  name,
  range,
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div className={cn('product-headline', className)}>
      {goBack && (
        <Button className="goback" onClick={history.goBack}>
          <ArrowLeftIcon className="icon" />
        </Button>
      )}
      {lengthName ? (
        <ShowMoreName context="product-h1" name={name} />
      ) : (
        <h2 className="h2" data-qa-id="product-h1">
          {name}
        </h2>
      )}
      {complementaryDescription && (
        <div className="product-headline__complementary-description">
          {complementaryDescription}
        </div>
      )}
      {(brand || range) && (
        <div className="product-headline__infos" data-qa-id="product-range">
          {brand?.name && (
            <span data-qa-id="brand">
              <span className="label" data-qa-id="label">
                {t('common:entities:product.brand')}
              </span>
              <span className="value" data-qa-id="value">
                {brand?.name}
              </span>
            </span>
          )}
          {brand && range && <span> - </span>}
          {range && (
            <span data-qa-id="range">
              <span className="label" data-qa-id="label">
                {t('common:entities:product.range')}
              </span>
              <span className="value" data-qa-id="value">
                {range}
              </span>
            </span>
          )}
        </div>
      )}
    </div>
  );
};

Headline.defaultProps = {
  ...HeadlineDefaultProps,
};

Headline.propTypes = {
  ...HeadlinePropTypes,
};

export default Headline;
